<template>
    <DCard
        padding
    >
        <DForm @submit.prevent="submitForm">
            <DFormRow
                :label="__('customers.upload_dpa.version')"
                is-required
                :error="form.errors.version"
            >
                <DSelect
                    id="version"
                    v-model="form.version"
                    :options="versions"
                    :placeholder="__('customers.upload_dpa.placeholders.version')"
                    :is-valid="isFormFieldValid('version')"
                />
            </DFormRow>
            <DFormRow
                :label="__('customers.upload_dpa.signed_at')"
                is-required
                :error="form.errors.signed_at"
            >
                <DDateFormatInput
                    id="signed_at"
                    v-model="form.signed_at"
                    format="YYYY-MM-DD"
                    type="date"
                    :is-valid="isFormFieldValid('signed_at')"
                />
            </DFormRow>
            <DFormRow
                :label="__('customers.upload_dpa.file')"
                is-required
                :error="form.errors.file"
                :hint="form.file ? form.file.name : __('customers.upload_dpa.placeholders.file')"
            >
                <DFileInput
                    id="file"
                    :custom="true"
                    :multiple="false"
                    :is-valid="isFormFieldValid('file')"
                    @change="addFile"
                />
            </DFormRow>

            <DFormControls
                :dirty="form.isDirty"
                @submit="submitForm"
            />
        </DForm>
    </DCard>
</template>

<script>
import CustomerBase from '~@/Pages/Customers/Base'
import App from '~@/App.vue'

export default {
    name: 'CustomerDpa',
    layout: [App, CustomerBase],
    props: {
        versions: {
            type: Array,
            default () { return [] }
        },
        customer: {
            type: Object,
            default: () => { return {} }
        }
    },
    data () {
        return {
            form: this.$inertia.form({
                file: null,
                version: this.version ?? null,
                signed_at: this.signed_at ?? null
            })
        }
    },
    methods: {
        submitForm () {
            this.form.post(this.$route('customers.customers.upload-dpa.store', {
                customer: this.customer.id
            }))
        },
        addFile (fileList) {
            this.form.file = fileList[0]
        }
    }
}
</script>
